var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trading_page"},[_c('div',{staticClass:"trading_title"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"rules_content",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }